import { render, staticRenderFns } from "./telPer.vue?vue&type=template&id=06dc373b&scoped=true&"
import script from "./telPer.vue?vue&type=script&lang=js&"
export * from "./telPer.vue?vue&type=script&lang=js&"
import style0 from "./telPer.vue?vue&type=style&index=0&id=06dc373b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc373b",
  null
  
)

export default component.exports